import React from "react";
import styles from "./index.module.scss";
import { Icon } from "antd";
import { Link, useRouteMatch } from "react-router-dom";
import TimeLimit from "./Components/TimeLimit";
import { DiscussListItem } from "../../../../../API/discuss";
import { isTrue } from "../../../../../Utils/filter";
import ListStatus from "../ListStatus";

interface ListItemProps {
    data: DiscussListItem;
}

export default function ListItem({ data }: ListItemProps) {
    const { path } = useRouteMatch();

    return (
        <Link to={`${path}/${data.uuid}`}>
            <div className={styles.root}>
                <div className={styles.titleRow}>
                    <h1 className={styles.title}>{data.topicName}</h1>
                    <ListStatus status={data?.statusQuery?.status} />
                </div>
                <div>
                    <Link
                        to={`${path}/${data.uuid}`}
                        className={styles.summary}
                        dangerouslySetInnerHTML={{ __html: data.topicContent }}
                    />
                </div>
                <div className={styles.footer}>
                    <div className={styles.info}>
                        <TimeLimit data={data} />
                        <span>
                            {isTrue(data.canMutualReplay) ? "允许" : "禁止"}
                            相互回复
                        </span>
                        <span>{isTrue(data.showLike) ? "" : "不"}展示赞同</span>
                        <span>
                            {isTrue(data.showDislike) ? "" : "不"}展示不赞同
                        </span>
                        <span>
                            {isTrue(data.showStudentName) ? "" : "不"}
                            展示学生姓名
                        </span>
                    </div>
                    <div className={styles.statics}>
                        <span>
                            <Icon type="solution" />
                            {data.statics?.partInCount || 0}
                            人参与
                        </span>
                        <span>
                            <Icon type="message" />
                            {data.statics?.replyCount || 0}条发言
                        </span>
                    </div>
                </div>
            </div>
        </Link>
    );
}
